import axios from 'axios';

const API_URL = '/api/books';

const booksService = {
  // Get all books with pagination and filters
  getAll: async (params = {}) => {
    const response = await axios.get(API_URL, {
      params,
      withCredentials: true
    });
    return response.data;
  },

  // Get single book by ID
  getById: async (id) => {
    const response = await axios.get(`${API_URL}/${id}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Create new book with file upload
  create: async (formData) => {
    const response = await axios.post(API_URL, formData, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 600000 // 10 minutes timeout for large files (250MB+)
    });
    return response.data;
  },

  // Create new book with progress callback
  createWithProgress: async (formData, onProgress) => {
    const response = await axios.post(API_URL, formData, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 600000, // 10 minutes timeout for large files (250MB+)
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (onProgress) {
          onProgress(percentCompleted);
        }
      }
    });
    return response.data;
  },

  // Update book
  update: async (id, data) => {
    const response = await axios.put(`${API_URL}/${id}`, data, {
      withCredentials: true
    });
    return response.data;
  },

  // Delete book
  delete: async (id) => {
    const response = await axios.delete(`${API_URL}/${id}`, {
      withCredentials: true
    });
    return response.data;
  }
};

export default booksService;
